import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import Modalizer from 'components/modalizer/modalizer'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import Select from 'components/select/select'
import { CancelButton, MainButton } from 'components/button'

import styles from './timer_modal.scss'

class TimerModal extends PureComponent {

	constructor() {
		super()
		this.state = {
			selectedMinute: null,
			selectedSecond: null,
		}

		this.minuteChange = this.minuteChange.bind(this)
		this.secondChange = this.secondChange.bind(this)
		this.save = this.save.bind(this)
	}

	componentWillMount() {
		this.setState({
			selectedMinute:
				this.props.value
					? Math.floor(this.props.value/60)
					: null,
			selectedSecond: this.props.value ? this.props.value%60: null,
		})
	}

	makeMinuteOptions(min, max) {
		const options = []
		for (let i = min; i < max/60; i++) {
			options.push({
				key: i,
				text: i < 10 ? `0${i}` : i,
			})
		}
		return options
	}

	makeSecondOptions(min, max, step) {
		max =
			this.state.selectedMinute
				? max - this.state.selectedMinute * 60
				: max
		max = Math.min(59, max)
		const options = []
		for (let i = 0; i <= max; i+=step) {
			options.push({
				key: i,
				text: i < 10 ? `0${i}` : i,
			})
		}
		return options
	}

	minuteChange(value) {
		let selectedSecond =
			this.state.selectedSecond
				? this.state.selectedSecond
				: 0
		if (value * 60 + selectedSecond > this.props.max) {
			selectedSecond =
				Math.floor((this.props.max - value * 60) / this.props.step)
				* this.props.step
		}
		this.setState({
			selectedMinute: value,
			selectedSecond,
		})
	}

	secondChange(value) {
		this.setState({
			selectedMinute:
				this.state.selectedMinute
					? this.state.selectedMinute
					: 0,
			selectedSecond: value,
		})
	}

	save() {
		let value = this.state.selectedMinute * 60 + this.state.selectedSecond
		if (value > this.props.max) {
			value = this.props.max
		}
		this.props.saveHandler(value)
	}

	render() {
		return (
			<Modalizer width='330px' closeAction={this.props.closeModalHandler}>
				<SecondaryTitle isCentered={true}>
					{this.props.title}
				</SecondaryTitle>
				<p styleName='subtitle'>{localize('timer_modal_text')}</p>
				<div styleName='options'>
					<div styleName='options-select'>
						<Select
							onChange={this.minuteChange}
							key_name='key'
							text_key='text'
							options={
								this.makeMinuteOptions(
									this.props.min,
									this.props.max
								)
							}
							placeholder='--'
							value={this.state.selectedMinute}
							fontSize='big'
						/>
						<span styleName='options-select-text'>
							{localize('timer_modal_minutes')}
						</span>
					</div>
					<span styleName='options-colon'>:</span>
					<div styleName='options-select'>
						<Select
							onChange={this.secondChange}
							key_name='key'
							text_key='text'
							options={
								this.makeSecondOptions(
									this.props.min,
									this.props.max,
									this.props.step
								)
							}
							placeholder='--'
							value={this.state.selectedSecond}
							fontSize='big'
						/>
						<span styleName='options-select-text'>
							{localize('timer_modal_seconds')}
						</span>
					</div>
				</div>
				<div styleName='btn-bar'>
					<div styleName='btn-container'>
						<CancelButton onClick={this.props.cancelHandler}>
							{localize('timer_modal_cancel')}
						</CancelButton>
					</div>
					<div styleName='btn-container'>
						<MainButton
							disabled={
								!this.state.selectedMinute
								&& !this.state.selectedSecond
							}
							onClick={this.save}
						>
							{this.props.saveButtonLabel}
						</MainButton>
					</div>
				</div>
			</Modalizer>
		)
	}
}

TimerModal.propTypes = {
	title: PropTypes.string,
	saveButtonLabel: PropTypes.string,
	max: PropTypes.number,
	min: PropTypes.number,
	step: PropTypes.number,
	value: PropTypes.number,
	saveHandler: PropTypes.func,
	cancelHandler: PropTypes.func,
	closeModalHandler: PropTypes.func,
}

TimerModal.defaultProps = {
	title: localize('timer_modal_title'),
	saveButtonLabel: localize('timer_modal_add'),
	max: 5999,
	min: 0,
	step: 15,
	value: 0,
	saveHandler: () => {},
	cancelHandler: () => {},
	closeModalHandler: () => {},
}

export default CSSModules(TimerModal, styles, {allowMultiple: true})
